import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import CallInfo from '../../component/CallInfo';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import AccountList2 from '../../component/Account/AccountList2';
import AccountList from '../../component/Account/AccountList';
import Information from '../../component/Information';
import Main_Spring from '../../component/Spring/Main_Spring';
import Save_Date from '../../component/Save_Date';
import Info_Spring from '../../component/Spring/Info_Spring';
import Info_Spring2 from '../../component/Spring/Info_Spring2';
import ParentInfo from '../../component/Info/ParentInfo';
import winterMusicFile from "../../asset/music/winter.mp3";


const ParkBoMyeong = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "경석 ♥ 보명 결혼합니다.";
    const openDesc = "2025년 5월 17일 오전 11시";
    const openThumb = "https://moodsean.s3.ap-northeast-2.amazonaws.com/159/thumb.jpg";

    const lng = 127.444813489524;
    const lat = 36.8489258516629 ;

    const placeTelNum = "043-534-2080";

    const forCar = "ㆍ서울방향 : 진천 IC 좌회전 → 신성사거리 직진 \n    → 신성사거리 우회전 → 포레스트 한울 웨딩홀\nㆍ수원방향 : 중부고속도로(대전방면) → 진천 IC\nㆍ청주방향 : 17번 국도(진천 )→ 원동교차로 직진 \n    → 신정사거리 좌회전 → 포레스트 한울 웨딩홀\nㆍ부산방향 : 경부고속도로(남이분기점) → 중부고속도로\n    (서청주방면) → 진천 IC"
    
    {/* const parents = [
        {groom : "김두희 · 이연숙의 장남"},
        {bride : "❁이석원 · 박영란의 차녀"}
    ] */}

    // const parentInfo = {
    //     groom: {
    //         dad: { name: "명남식", isDeceased: false },
    //         mom: { name: "안인순", isDeceased: true },
    //         role: "아들",
    //     },
    //     bride: {
    //         dad: { name: "이금하", isDeceased: false },
    //         mom: { name: "구은숙", isDeceased: false },
    //         role: "딸",
    //     }
    // };

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    // #E08514
    // #EFD140
    // #EB9217
    // #ff8faf
    // #E25B34
    // #edacb1
    // #E59F9D 연핑크
    // #d48a87
    // #157f01
    // #B2C867
    // #D2CC5A
    const conceptStyle = {
        // spring 그린B
        concept: "SPRING",
        titleColor: "#648900",
        pointColor: "#648900",
        btnBgColor: "#c1d36e",
        fontColor: "#313131",
        btnFontColor: "#313131",
        chatBgColor: "#f0f4e1",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }

    const infoTitle = "우리 결혼합니다.";

    const msg1 = "스무 해 동안 친구로 함께 걷던 우리가\n이제는 서로의 반려로 걸음을 이어가려 합니다.";
    const msg2 = "함께할 인생의 모든 계절 동안\n서로에게 유일한 사람으로 머물겠습니다."
    const msg3 = "5월의 어느 봄날, \n곁에서 아껴주셨던 고마운 분들을 모십니다.\n귀한 걸음 하시어 기쁜 날을 함께 축복해 주시면 감사하겠습니다.";

    const groomAccountList = [
        {
            role: "신랑",
            name: "심경석",
            bank: "농협은행",
            accountNumber : "302-1894-7521-51",
            isKakao : false
        }
        ,{
            role: "신랑 부",
            name: "심명기",
            bank: "농협은행",
            accountNumber : "415060-52-026602",
            isKakao : false
        }
        ,{
            role: "신랑 모",
            name: "전성임",
            bank: "농협은행",
            accountNumber : "415068-52-132621",
            isKakao : false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "박보명",
            bank: "신한은행",
            accountNumber : "110-461-310522",
            isKakao : false
        }
        ,{
            role: "신부 부",
            name: "박동규",
            bank: "농협은행",
            accountNumber : "415068-52-091816",
            isKakao : false
        }
        ,{
            role: "신부 모",
            name: "최인순",
            bank: "농협은행",
            accountNumber : "415068-56-063451",
            isKakao : false
        }
    ]


    const account_explain = ""

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "김진모",
            call: "010-9325-9759"
        }
        // ,{
        //     role: "신랑 부",
        //     name: "조진기",
        //     call: "010-4880-3897"
        // }
        // ,{
        //     role: "신랑 모",
        //     name: "차영애",
        //     call: "010-8557-3897"
        // }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "유진영",
            call: "010-2586-0473"
        }
        // ,{
        //     role: "신부 부",
        //     name: "이태영",
        //     call: "010-9333-2361"
        // },
        // {
        //     role: "신부 모",
        //     name: "석현주",
        //     call: "010-4382-1025"
        // }
    ]

    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 기억해?",
            groomAnswer: "예쁘고친절",
            brideAnswer: "성실부지런"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "새로운시작",
            brideAnswer: "희망찬앞날"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "나만믿어요",
            brideAnswer: "항상응원해"
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "배려와양보",
            brideAnswer: "존중과믿음"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "축하와격려",
            brideAnswer: "고맙습니다"
        }
    ]

    const informationList =[
        {
            title : "♥신랑신부가 준비한 포토부스 이벤트♥",
            content : "10시30분-12시 운영합니다! \n많이 참여해주세요\n\n예쁜사진과 축하메시지를 남겨주시고,\n인생사진도 마음껏 가져가세요 :D"
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  // Call once on mount
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    const toUpperCaseString = (str) => {
        const nameParts = str.split(' '); 
        return nameParts.slice(1).join(' ').toUpperCase();
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstEnName = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };


    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#648900"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept} musicTitle={winterMusicFile}/>
                    <Main_Spring groomNameEn={toUpperCaseString(weddingData.groomNameEn)} brideNameEn={toUpperCaseString(weddingData.brideNameEn)} weddingData={weddingData} color={conceptStyle.pointColor}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={false} marginTop={"100px"} marginBottom={"0px"} fontSize={"16px"}/>
                    <Info_Spring2 weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>     
                    <Letter title={infoTitle} msg1={msg1} msg2={msg2} msg3={msg3} conceptStyle={conceptStyle}/>
                    {/* <MotionWrapper initialY={70}>
                        <ParentInfo conceptStyle={conceptStyle} parentInfo={parentInfo} weddingData={weddingData}/>
                    </MotionWrapper> */}
                    {/* <CallInfo conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/> */}
                    <Dday_Spring isAttendFromClose={true} groomName={getFirstKoName(weddingData.groomName)} brideName={getFirstKoName(weddingData.brideName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={6} photoWidth={"150px"} photoHeight={"235px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>    
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>    
                    <MotionWrapper initialY={50}>
                            {/* <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} /> */}
                            <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>    
                    <Location_Desc forCar={forCar} conceptStyle={conceptStyle}/>
                    {/* <Information titleFontSize={"15px"} pointFontColor={"#9b111e"} conceptStyle={conceptStyle} informationList={informationList} /> */}
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default ParkBoMyeong;